import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useSearchParams } from 'react-router-dom';
import { deleteMADAA020, postMADAA010, postMADAA020 } from '../../../services/Api';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_CV } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas } from '../../../utils';

registerLocale('ko', ko);

const MADAA010 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const [data, setData] = useState([]);
    const [countRowsResumeLvl, setCountRowsResumeLvl] = useState('');
    const [searchCondition, setSearchCondition] = useState('MemberID');
    const [keyword, setKeyword] = useState('');
    const [dateRate, setDateRate] = useState('');

    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [resumeLvl, setResumeLvl] = useState('');

    const getSearchCondition = (e) => {
        const selectedValue = e.target.value;
        setSearchCondition(selectedValue);
    };

    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        setDateRate('');
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const handleRadioBoxChange = (e) => {
        const value = e.target.value;
        setResumeLvl(value);
    };

    const getListData = (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postMADAA010({
            page: currentPage,
            searchCondition,
            resumeLvl: resumeLvl === '' ? null : resumeLvl,
            keyword: keyword?.trim(),
            startDate: startDateFormated,
            endDate: endDateFormated,
        })
            .then(({ data }) => {
                setData(data.data.data);
                setPages(data.info);
                setCountRowsResumeLvl(data.data.countRowsResumeLvl);
            })
            .catch((error) => console.log(error));
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };

    const clickReset = () => {
        setSearchCondition('MemberID');
        setKeyword('');
        setStartDate('');
        setEndDate('');
        setResumeLvl('');
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    const handleDelete = (seq) => {
        const confirm = window.confirm('해당 이력서를 삭제하시겠습니까?');
        if (confirm) {
            deleteMADAA020(seq)
                .then(() => {
                    window.alert('삭제 완료되었습니다.');
                    getListData();
                })
                .catch((error) => console.log(error));
        }
    };
    const handleChangeLvl = (seq) => {
        if (window.confirm('해당 이력서의 상태를 변경하시겠습니까?')) {
            postMADAA020(seq)
                .then(() => {
                    window.alert('상태 변경 완료되었습니다.');
                    getListData();
                })
                .catch((error) => console.log(error));
        }
    };

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_CV} />
                <div className="manager-continues content-right">
                    <div className="title title-manager-continues">인재정보</div>
                    <div id="search-box">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>조건검색</th>
                                    <td>
                                        <div className="select-box">
                                            <select onChange={getSearchCondition} value={searchCondition}>
                                                <option value="MemberID">아이디</option>
                                                <option value="NameKor">이름</option>
                                                <option value="Title">이력서 제목</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="검색어를 입력해 주세요."
                                                onChange={inputChange}
                                                value={keyword}
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter') {
                                                        clickSearch();
                                                    }
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>상태</th>
                                    <td>
                                        <fieldset id="radio-group" className="radio-group">
                                            <div className="item-radioBox">
                                                <input
                                                    type="radio"
                                                    name="resumeLvl"
                                                    value=""
                                                    id="resumeLvl_A"
                                                    checked={resumeLvl === ''}
                                                    onChange={handleRadioBoxChange}
                                                />
                                                <span />
                                                <label htmlFor="resumeLvl_A">
                                                    <span>전체</span>
                                                </label>
                                            </div>
                                            <div className="item-radioBox">
                                                <input
                                                    type="radio"
                                                    name="resumeLvl"
                                                    value="Y"
                                                    id="resumeLvl_Y"
                                                    checked={resumeLvl === 'Y'}
                                                    onChange={handleRadioBoxChange}
                                                />
                                                <span />
                                                <label htmlFor="resumeLvl_Y">
                                                    <span>공개</span>
                                                </label>
                                            </div>
                                            <div className="item-radioBox">
                                                <input
                                                    type="radio"
                                                    name="resumeLvl"
                                                    value="N"
                                                    id="resumeLvl_N"
                                                    checked={resumeLvl === 'N'}
                                                    onChange={handleRadioBoxChange}
                                                />
                                                <span />
                                                <label htmlFor="resumeLvl_N">
                                                    <span>비공개</span>
                                                </label>
                                            </div>
                                        </fieldset>
                                    </td>
                                </tr>
                                <tr>
                                    <th>등록일</th>
                                    <td>
                                        <div className="flex group-item header-item-inner">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                            <ul className="select-value">
                                                <li
                                                    value-date-range="today"
                                                    className={dateRate === 'today' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    오늘
                                                </li>
                                                <li
                                                    value-date-range="1week"
                                                    className={dateRate === '1week' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    일주일
                                                </li>
                                                <li
                                                    value-date-range="15days"
                                                    className={dateRate === '15days' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    15일
                                                </li>
                                                <li
                                                    value-date-range="1month"
                                                    className={dateRate === '1month' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    1개월
                                                </li>
                                                <li
                                                    value-date-range="3months"
                                                    className={dateRate === '3months' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    3개월
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="group-button center">
                            <button className="btn btn-gray-bold" onClick={clickSearch}>
                                검색
                            </button>
                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                초기화
                            </button>
                        </div>
                    </div>
                    <div className="results gray">
                        <div className="count">
                            총 등록 이력서 <span className="blue">{formatNumberWithCommas(pages?.totalRow || 0)}</span>
                            건 | 공개중인 이력서:{' '}
                            <span className="red">{formatNumberWithCommas(countRowsResumeLvl || 0)}</span>건
                        </div>
                        <table className="table-gray">
                            <thead>
                                <tr>
                                    <th>아이디(이름)</th>
                                    <th>이력서 제목</th>
                                    <th>희망업종</th>
                                    <th>소지자격증</th>
                                    <th>희망 근무형태</th>
                                    <th>희망 근무지역</th>
                                    <th>희망급여</th>
                                    <th>경력사항</th>
                                    <th>상태</th>
                                    <th>
                                        수정일
                                        <br />
                                        (등록일)
                                    </th>
                                    <th>관리</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <Link to={`/mabaa030-${item?.memberSeq}?tbl=GM&gbn=P`}>
                                                    {item?.memberID}
                                                </Link>
                                            </td>
                                            <td>
                                                <Link to={`/madaa020-${item?.seq}`}>{item?.title}</Link>
                                            </td>
                                            <td>{item?.resumeClass}</td>
                                            <td>{item?.resumeLicense}</td>
                                            <td>{item?.resumeForm}</td>
                                            <td>
                                                {item?.resumeRegionSi1 &&
                                                    item?.resumeRegionGu1 &&
                                                    `1차 ${item?.resumeRegionSi1} ${item?.resumeRegionGu1}`}
                                                <br />
                                                {item?.resumeRegionSi2 &&
                                                    item?.resumeRegionGu2 &&
                                                    `2차 ${item?.resumeRegionSi2} ${item?.resumeRegionGu2}`}
                                                <br />
                                                {item?.resumeRegionSi3 &&
                                                    item?.resumeRegionGu3 &&
                                                    `3차 ${item?.resumeRegionSi3} ${item?.resumeRegionGu3}`}
                                            </td>
                                            <td>
                                                {item?.resumePay} {item?.resumePayEtc}
                                            </td>
                                            <td>{item?.resumeCareer}</td>
                                            <td>{item?.resumeLvl === 'Y' ? '공개' : '비공개'}</td>
                                            <td>
                                                {formatDate(item?.modDate)}
                                                <br />({formatDate(item?.addDate)})
                                            </td>
                                            <td>
                                                <Link
                                                    onClick={() => {
                                                        handleDelete(item?.seq);
                                                    }}
                                                >
                                                    삭제
                                                </Link>
                                                <br />
                                                <Link
                                                    onClick={() => {
                                                        handleChangeLvl(item?.seq);
                                                    }}
                                                >
                                                    변경
                                                </Link>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={11}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MADAA010;
